//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

import { shallowEqual, useSelector } from "react-redux";



//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const loaderClassActivityAndQuizSelector = (state) => state.loaderClassActivityAndQuiz;

//  -- Examples array selector --------
export const useLoadQuizAndClassActivity = () =>{
    const selectedData = useSelector(loaderClassActivityAndQuizSelector, shallowEqual)
    return selectedData;
}
